import React, {
  useState,
  useEffect,
  createContext,
  useReducer,
  useContext,
  useMemo,
} from "react";
import "./notification.css";
import { FilledInfoIcon } from "./icons/filled-info";
import { FilledAlertCircleIcon } from "./icons/filled-alert-circle";
import { FilledCircleCheckIcon } from "./icons/filled-circle-check";
import { FilledAlertIcon } from "./icons/filled-alert";
import { XIcon } from "./icons/x";

const NOTIFICATION_ICON_MAP = {
  warning: FilledAlertCircleIcon,
  success: FilledCircleCheckIcon,
  error: FilledAlertIcon,
  info: FilledInfoIcon,
};

const initialValue = {};
export const NotificationContext = createContext(initialValue);

export const NotificationState = ({ children }) => {
    const [notifications, dispatch] = useReducer((state, action) => {
        switch (action.type) {
            case "add":
                const message = action.notification;
                const existsMessage =
                  Object.values(state).filter((notification) => {
                    return (
                      notification.type === message.type &&
                      notification.message === message.message
                    );
                }).length > 0;
                if (!existsMessage) {
                    state[action.notification.id] = action.notification;
                }
                return { ...state };
            case "remove":
                const newState = { ...state };
                delete newState[action.notification.id];
                return newState;
            default:
                return state;
        }
    }, initialValue);
    const addToast = (message, type, style = null) => {
        const crypto = window.crypto ||
          window.msCrypto || { getRandomValues: () => "test" };
        const id = crypto.getRandomValues(new Uint32Array(1)).toString();
        const newNotification = { message, type, id, style };
        dispatch({ type: "add", notification: newNotification });
    };
    const removeToast = (notification) => {
        dispatch({ type: "remove", notification });
    };
    return (
        <NotificationContext.Provider
          value={{ notifications, addToast, removeToast }}
        >
          {children}
          <div className="ui-notification-container">
            {Object.values(notifications).map((notification) => (
              <NotificationMessage
                key={notification.id}
                notification={notification}
              />
            ))}
          </div>
        </NotificationContext.Provider>
    );
};
const NotificationMessage = ({ notification }) => {
    const { type, message, style } = notification;
    const [transition, setTransition] = useState("");
    const globalState = useContext(NotificationContext);
    const { removeToast } = globalState;
    useEffect(() => {
        let showTimer;
        const timer = setTimeout(() => {
            showTimer = setTimeout(() => {
                clearTimeout(showTimer);
                removeToast(notification);
            }, 1000);

            if (transition !== "killed") {
              setTransition("killed");
            }
        }, 5000);
        return () => clearTimeout(timer);
    });

    const icon = useMemo(() => {
      const IconComponent = NOTIFICATION_ICON_MAP[type] || NOTIFICATION_ICON_MAP.info;
      return <IconComponent className={`zds-banner-icon ${type}`} />;
    }, [type]);

    return (
        <div style={style} className={`zds-banner ${transition}`}>
            <div className="zds-banner-header">
                {icon}
                <h5 className="zds-banner-title text-system-neutral-1000">{type}</h5>
                <button
                  className="zds-button-tertiary-subtle zds-button-icon-xsmall"
                  onClick={() => removeToast(notification)}
                >
                    <XIcon />
                </button>
            </div>
            <div className="zds-banner-description zds-text-system-neutral-800">
                {message}
            </div>
        </div>
    );
};
